module.exports = __webpack_public_path__ + "fonts/ebbeb79e6b0c7047a04879e32acc0aa7-Roboto-MediumItalic.ttf";